import { IPaginatedParams, PageInfo, TestSideEnums } from '../../share-types'

export interface IPlanFilterParams {
  name?: string
  status?: PlanStatusEnums
  planType?: PlanTypeEnums
  isTopUp?: boolean
  isNewUserOnly?: boolean
}

export enum PlanStatusEnums {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  DELETED = 'deleted',
}

export enum PlanTypeEnums {
  REGULAR = 'REGULAR',
  LONG_TERM_PRICING = 'LONG_TERM_PRICING',
  LITE = 'LITE',
  FIXED = 'FIXED',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export enum SubscriptionRenewalModeEnums {
  AUTO_RENEW = 'AUTO_RENEW',
  ONE_TIME = 'ONE_TIME',
}

export interface IPlanTranslation {
  id?: number
  locale: string
  name: string
  marketingHeading?: string
  marketingSubHeading?: string
  appMarketingTagline1?: string
  appMarketingTagline2?: string
  appMarketingTagline3?: string
}

export interface IPlan {
  id: number
  name?: string
  externalId?: string
  description?: string
  price?: number
  originalPrice?: number
  period?: number
  periodUnit?: string
  validityPeriod?: number
  status?: PlanStatusEnums
  cityId?: number
  credits?: number
  isMiniProgram?: boolean
  miniProgramSelectable?: boolean
  marketingHeadingBgColor?: string
  planType: PlanTypeEnums
  isTopUp: boolean
  isNewUserOnly: boolean
  wechatContractPlanId?: number
  subscriptionRenewalMode?: SubscriptionRenewalModeEnums
  testSide?: TestSideEnums
  translations: IPlanTranslation[]
}

export interface IPlanFormData {
  name: string
  externalId?: string
  description?: string
  price: number
  originalPrice?: number
  credits: number
  validityPeriod?: number
  planType: PlanTypeEnums
  cityId?: number
  miniProgramSelectable: boolean
  isTopUp: boolean
  isNewUserOnly: boolean
  wechatContractPlanId?: number
  subscriptionRenewalMode?: SubscriptionRenewalModeEnums
  marketingHeadingBgColor?: string
  status: PlanStatusEnums
  testSide?: TestSideEnums
  translations: IPlanTranslation[]
}

export type PaginatedPlanFilterParams = IPaginatedParams & IPlanFilterParams

export type PaginatedPlan = {
  pageInfo: PageInfo
  data: IPlan[]
}
